"use client";

import { type ReactNode, type Ref, useEffect, useMemo, useState } from "react";

import { LayoutContextProvider } from "./context";

export interface LayoutProviderProps {
  children: ReactNode;
  className?: string;
  /**
   * Provided by AuthenticatedContainer.get(PHARADAY_BANNER)
   */
  banner: boolean;
  ref?: Ref<HTMLDivElement>;
}

const Provider = ({ children, banner }: LayoutProviderProps) => {
  const [openSidebar, setOpenSidebar] = useState<boolean | undefined>();
  const [contentBodyElement, setContentBodyElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setOpenSidebar(localStorage?.getItem("isLayoutSidebarOpen") === "false" ? false : true);
  }, []);

  // Breadcrumb state is owned by Layout.Root, not here — see the comment there.
  const providerSidebarValue = useMemo(
    () => ({
      openSidebar,
      setOpenSidebar,
      contentBodyElement,
      setContentBodyElement,
      banner,
    }),
    [openSidebar, contentBodyElement, banner]
  );

  useEffect(() => {
    localStorage?.setItem("isLayoutSidebarOpen", JSON.stringify(openSidebar));
  }, [openSidebar]);

  return <LayoutContextProvider value={providerSidebarValue}>{children}</LayoutContextProvider>;
};

Provider.displayName = "LayoutProvider";

export default Provider;
